var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer rounded transition duration-200",class:{
    'hover:bg-gray-200 p-1 mx-1': !_vm.group,
  },on:{"mouseover":_vm.play,"mouseleave":_vm.reset,"click":function($event){return _vm.$emit('click')}}},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":20,"width":20},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }